import { Toolbar } from '@mui/material'
import React, { useState } from 'react'
import { DashboardHead } from '../../Dashboard/DashboardPage'
import {
  DataTable,
  FilterSection,
  FilterStudent,
  SelectField,
  ToolbarComponent,
} from '../../../../../components'
import { teacherHeadCells } from '../../../../../shared/data/headCells'
import AddEmployee from '../Employee/components/AddEmployee'
import EmployeeDetail from '../Employee/components/EmployeeDetail'
import useTeacher from '../../../../../shared/hooks/useTeacher'
import { EditTeacher } from './component/EditTeacher'
import { urls } from '../../../../../shared/config'
import { useGlobal } from '../../../../../shared'
import { InfoField } from '../School/PopOver/SchoolInfo'
import { highestInt } from '../../../../../shared/utils/constants'
import { useSelector } from 'react-redux'
import NewSelectedField from '../../../../../common/NewSelectedField/NewSelectedField'
import IndividualTeacher from './component/IndividualStudent/IndividualTeacher'
import { ImportIcon } from '../../../../../assets/icons'
import { downloadCSV } from '../../../../../shared/config/downloadCSV'

const Teacher = () => {
  const [page, setPage] = React.useState(1)
  const rowsPerPage = useSelector((state) => state.global.rowsPerPage)

  const userSchoolId = localStorage.getItem('userSchoolId')
  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes)
  const customRole = attributes?.employee_type
  const [schoolName, setSchoolName] = React.useState('')

  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  const [search, setSearch] = useState('')

  const [addTeacher, setAddTeacher] = useState(false)
  const [detail, setDetail] = useState(false)
  const [section, setSection] = useState('')
  const [gradeValue, setGradeVal] = useState('')
  const [selectedGrade, setSelectedGrade] = useState('')
  const [selectedClass, setSelectedClass] = useState('')
  const [selectedMonth, setSelectedMonth] = useState('')

  const [update, setUpdate] = useState(false)
  // const { data: searchTeacher, count: searchCount } = useGlobal({
  //   userUrl: `${urls.TEACHER_SERACH}${search}&school_id=${customRole == 'Admin' ? userSchoolId : schoolName}&page=${page}&limit=${rowsPerPage}&grade_id=${selectedGrade}&section_id=${selectedClass}`,
  // })
  const { data: grades } = useGlobal({
    userUrl: `${urls.CLASS_GRADE}${customRole == 'Admin' ? userSchoolId : schoolName}&page=1&limit=1000`,
  })

  const {
    data: teacherOptions,
    count,
    refetch,
  } = useTeacher({
    schoolID: customRole == 'Admin' ? userSchoolId : schoolName,
    page: page,
    limit: rowsPerPage,
    search: search,
    grade_id: selectedGrade,
    section_id: selectedClass,
  })
  const rowData = teacherOptions
  const pagecount = count

  const handleClassChange = (event) => {
    const value = event.target.value
    setSelectedClass(value)
    // console.log('Selected class:', value)
    // You can pass this value to parent or apply filter here
  }
  const handleMonthChange = (event) => {
    const value = event.target.value
    setSelectedMonth(value)
    // console.log('Selected month:', value)
    // You can pass this value to parent or apply filter here
  }
  const individualTeacher = useSelector((state) => state.global.openIndividualTeacher)
  if (addTeacher) {
    return (
      <IndividualTeacher
        setAddTeacher={setAddTeacher}
        setUpdate={setUpdate}
        form
        refetch={refetch}
        setDetail={setDetail}
      />
    )
  }
  if (individualTeacher || detail) {
    return (
      <IndividualTeacher
        setAddTeacher={setAddTeacher}
        setDetail={setDetail}
        setUpdate={setUpdate}
        refetch={refetch}
        update={true}
      />
    )
  }
  if (update) {
    return (
      <IndividualTeacher
        setAddTeacher={setAddTeacher}
        setUpdate={setUpdate}
        refetch={refetch}
        setDetail={setDetail}
        update={update}
      />
    )
  }
  const handleExport = () => {
    if (rowData && rowData.length > 0) {
      // Generate filename with filters
      let filename = 'Teachers'

      if (schoolName) {
        const school = schoolList?.find((s) => s.school_id === schoolName)
        if (school) {
          filename += `_${school.school_name}`
        }
      }

      if (selectedGrade) {
        const grade = grades?.find((g) => g.grade_id === selectedGrade)
        filename += `_Grade_${grade?.grade || selectedGrade}`
      }

      if (selectedClass) {
        filename += `_Class_${selectedClass}`
      }

      // Add date
      const date = new Date().toISOString().split('T')[0]
      filename += `_${date}`

      downloadCSV(rowData, filename)
    } else {
      alert('No data to export')
    }
  }
  return (
    <div>
      <Toolbar />
      <DashboardHead title={'Teacher'} subtitle={'Class / Teacher'} />
      <div className="school-toolbar">
        <div style={{ width: '40%' }}>
          {customRole != 'Admin' ? (
            <SelectField
              placeholder={'Select School'}
              options={(schoolList || [])?.map((prod) => ({
                value: prod.school_id,
                label: prod.school_name,
              }))}
              name="schoolName"
              value={schoolName}
              onChange={(selectedOption) => {
                setSchoolName(selectedOption)
                setPage(1)
              }}
            />
          ) : (
            <InfoField value={userSchoolName} />
          )}
        </div>
      </div>
      <ToolbarComponent
        handleOpen={() => setAddTeacher(true)}
        search={search}
        setSearchItem={setSearch}
        setPage={setPage}
      >
        {/* <FilterStudent
          section={section}
          setSection={setSection}
          gradeValue={gradeValue}
          setGradeVal={setGradeVal}
          school_id={
            customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : schoolName
          }
          teacher
        /> */}
        <NewSelectedField
          student={true}
          selectedGrade={selectedGrade}
          selectedMonth={selectedMonth}
          selectedClass={selectedClass}
          school_id={customRole == 'Admin' ? userSchoolId : schoolName}
          grades={grades}
          handleClassChange={handleClassChange}
          handleMonthChange={handleMonthChange}
          setSelectedClass={setSelectedClass}
          setSelectedGrade={setSelectedGrade}
          setSelectedMonth={setSelectedMonth}
        />
        <FilterSection icon={ImportIcon} onClick={handleExport} title={'Export'} />
      </ToolbarComponent>
      <DataTable
        rowData={rowData}
        headCells={teacherHeadCells}
        handleDetailOpen={() => setDetail(true)}
        teacher
        pageFee={page}
        pages
        setPageFee={setPage}
        setUpdate={setUpdate}
        pageCount={pagecount}
        refetch={refetch}
      />
      {/* {addTeacher && (
        <IndividualTeacher
          customRole={customRole}
          userSchoolId={userSchoolId}
          title={'Add Teacher'}
          open={addTeacher}
          teacher
          handleClose={() => setAddTeacher(false)}
        />
      )} */}
      {/* {detail && <EmployeeDetail teacher open={detail} handleClose={() => setDetail(false)} />} */}
      {/* {update && <EditTeacher open={update} handleClose={() => setUpdate(false)} />} */}
    </div>
  )
}

export default Teacher
